<div class="page-container">
  <app-toolbar [title]="'COMMON.UPLOAD_CALL' | translate"></app-toolbar>
  <div class="page">
    <div class="step-progress-container">
      <app-step-progress [steps]="stepLabels" [currentStep]="1" [disabled]="true"></app-step-progress>
    </div>

    <div class="setup-content">
      @if (data !== null) {
        <div class="step-card">
          <div class="step-header">
            <h3>{{ 'CALL_SETUP.CREATE_CALL.STEP_TITLE' | translate }}</h3>
            <p>{{ 'CALL_SETUP.UPLOAD_CALL.DESCRIPTION' | translate }}</p>
          </div>

          <div class="meeting-details-form">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>{{ 'CALL_SETUP.CALL_DETAILS.CALL_NAME' | translate }}</mat-label>
              <input matInput [(ngModel)]="data.name" required />
            </mat-form-field>

            <app-datetime-picker [(ngModel)]="data.date" [required]="true" translationKey="CALL_SETUP.CALL_DETAILS.CALL_DATE"></app-datetime-picker>

            @if (organizationUsersWithoutCurrentUser$ | async; as result) {
              @if (result.isSuccess) {
                <app-selection
                  labelKey="COMMON.ADDITIONAL_CALL_OWNERS"
                  idField="id"
                  nameField="fullName"
                  [options]="addFullNameToUserList(result.data!)"
                  (selectionChange)="onUserSelectionChange($event)"
                ></app-selection>
                <div class="disclaimer-box">
                  <mat-icon class="disclaimer-icon">info</mat-icon>
                  {{ 'UPLOAD_CALL.DISCLAIMER' | translate }}
                </div>
              }
            }
          </div>

          <div class="step-actions">
            @if (uploadCallMutation.result$ | async; as result) {
              @if (result.isPending) {
                <mat-spinner diameter="20"></mat-spinner>
              } @else {
                <button mat-flat-button color="primary" (click)="onCreateCallClicked()" [disabled]="isCreateButtonDisabled">
                  {{ 'CALL_SETUP.CALL_DETAILS.CREATE_CALL' | translate }}
                </button>
              }
            }
          </div>
        </div>
      }
    </div>
  </div>
</div>
